import React from "react";
import styled from "styled-components";
import SearchBar from "../common/Search/SearchBar";

// Container principal
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  top: 0px;
  align-items: center;
  padding: 18px 18px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #ddd;
  width: 100%;

  @media (max-width: 768px) {
    padding: 100%;
  }
`;

const HighlightedText = styled.span`
  color: #ff9f1f;
  font-style: italic;
`;

// Texto estilizado
const WelcomeText = styled.div`
  font-size: 18px;
  padding-left: 15px;
  color: black;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 16px; /* Reduz o tamanho da fonte em telas pequenas */
  }
`;

const BemVindoWrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px; /* Ajuste para a altura do Navbar em telas pequenas */
  }
`;

const BemVindoComponent = () => {
  return (
    <BemVindoWrapper>
      <Container>
        <WelcomeText>
          <HighlightedText>Bem-vindo</HighlightedText> ao módulo de atividades práticas / Estágios
        </WelcomeText>
        <SearchBar />
      </Container>
    </BemVindoWrapper>
  );
};

export default BemVindoComponent;